import { graphql } from '../../gql';

export const TRANSITIONS_V2_DATA = graphql(`
  query TransitionV2Data($req: TransitionsReqV2) {
    transitionsV2(req: $req) {
      entities {
        metadata {
          id
          short_name
          long_name
          type
        }
        metrics {
          flows {
            inflows {
              id
              short_name
              long_name
              count
              share
            }
            outflows {
              id
              short_name
              long_name
              count
              share
            }
            inflows_remaining {
              count
              share
            }
            outflows_remaining {
              count
              share
            }
          }
          breakdowns {
            role {
              id
              short_name
              long_name
              current_count
              current_share
              inflows_count
              inflows_share
              outflows_count
              outflows_share
              __typename
            }
            rics {
              id
              short_name
              long_name
              current_count
              current_share
              inflows_count
              inflows_share
              outflows_count
              outflows_share
              __typename
            }
            geography {
              id
              short_name
              long_name
              current_count
              current_share
              inflows_count
              inflows_share
              outflows_count
              outflows_share
              __typename
            }
            seniority {
              id
              short_name
              long_name
              current_count
              current_share
              inflows_count
              inflows_share
              outflows_count
              outflows_share
              __typename
            }
            gender {
              id
              short_name
              long_name
              current_count
              current_share
              inflows_count
              inflows_share
              outflows_count
              outflows_share
              __typename
            }
            ethnicity {
              id
              short_name
              long_name
              current_count
              current_share
              inflows_count
              inflows_share
              outflows_count
              outflows_share
              __typename
            }
            education {
              id
              short_name
              long_name
              current_count
              current_share
              inflows_count
              inflows_share
              outflows_count
              outflows_share
              __typename
            }
          }
        }
      }
    }
  }
`);
